export default "__VITE_ASSET__B7J3axoh__"